<template>
  <el-about-window
    class="v-about"
    append-to-body
    :title="brandTitle"
    :visible.sync="visible"
    @close="onClose"
  >
    <template #logo>
      <img
        height="112px"
        :src="themeData.aboutLogo"
        :alt="brandTitle"
        width="112px"
      />
    </template>
    <template #versions>
      <span>{{ $t('Version: {serverVersion} (build {serverRelease})', { serverVersion, serverRelease }) }}</span>
    </template>
    <template #links>
      <a
        class="hci-el-text--link"
        :href="themeData.docsLink"
        target="blank"
      >
        {{ $t('Documentation') }}
      </a>
      <a
        class="hci-el-text--link"
        :href="themeData.supportLink"
        target="blank"
      >
        {{ $t('Support information') }}
      </a>
      <a
        class="hci-el-text--link"
        :href="themeData.isoLink"
        target="blank"
      >
        {{ $t('ISO') }}
      </a>
      <a
        class="hci-el-text--link"
        :href="themeData.contactUsLink"
        target="blank"
      >
        {{ $t('Contact support') }}
      </a>
      <a
        class="hci-el-text--link"
        :href="themeData.termsLicenses"
        target="blank"
      >
        {{ $t('Terms & licenses') }}
      </a>
      <a
        class="hci-el-text--link"
        :href="themeData.productPage"
        target="blank"
      >
        {{ $t('Product page') }}
      </a>
    </template>
  </el-about-window>
</template>

<script>
  import { mapState, mapStores } from 'pinia';
  import useVersionsStore from '@/common/store/pinia/versions';
  import useThemeStore from '@/common/store/pinia/theme';

  export default {
    name: 'About',
    data() {
      return {
        visible: true,
      };
    },
    created() {
      this.versionsStore.fetchAbout();
    },
    computed: {
      ...mapStores(useVersionsStore),
      ...mapState(useVersionsStore, ['serverVersion', 'serverRelease']),
      ...mapState(useThemeStore, ['themeData']),
      brandTitle() {
        const words = this.themeData.productName.split(' ');
        if (words.length === 2) {
          return `${this.themeData.productName}\xa0`;
        }
        words.splice(1, 2, `${words[1]}\xa0${words[2]}`);
        return words.join(' ');
      },
    },
    methods: {
      onClose() {
        this.visible = false;
        this.$emit('close');
      },
    }
  };
</script>
